export default __webpack_public_path__ + "img/356eabffc90e3b0dd423f322d1d8f309.svg";